/**
 * @component ContactPage
 * @description 비즈니스 목적: 문의 작성 화면을 제공하고 이메일 접수 흐름을 처리합니다.
 */

import ContactFormPanel from '../../components/contact/ContactFormPanel';
import ModalPopup from '../../components/common/ModalPopup';
import PageHero from '../../components/common/PageHero';
import { pageMeta } from '../../constants/navigation';
import { inquiryTypes, privacyPolicyText } from '../../constants/supportData';
import { useContactForm } from '../../hooks/useContactForm';

export default function ContactPage({ onNavigate }) {
  const {
    clearPrivacyError,
    closeForm,
    closeSendFailModal,
    closeSuccessModal,
    errors,
    formState,
    handleChange,
    handleMessageChange,
    handleSubmit,
    isSendFailModalOpen,
    isSubmitting,
    isSuccessModalOpen,
    isWriting,
  } = useContactForm(onNavigate);

  return (
    <>
      <PageHero title={pageMeta.contact.title} trail={pageMeta.contact.trail} className="cs-page-hero" />
      <section className="section">
        <div className="container contact-container">
          {isWriting ? (
            <ContactFormPanel
              clearPrivacyError={clearPrivacyError}
              closeForm={closeForm}
              errors={errors}
              formState={formState}
              handleChange={handleChange}
              handleMessageChange={handleMessageChange}
              handleSubmit={handleSubmit}
              inquiryTypes={inquiryTypes}
              isSubmitting={isSubmitting}
              privacyPolicyText={privacyPolicyText}
            />
          ) : null}
        </div>
      </section>

      <ModalPopup
        isOpen={isSuccessModalOpen}
        message={'문의가 정상적으로 접수되었습니다. 확인 후 연락드리겠습니다.'}
        onConfirm={closeSuccessModal}
      />
      <ModalPopup
        isOpen={isSendFailModalOpen}
        message={'문의 전송에 실패했습니다. 대표 전화로 문의 바랍니다.'}
        onConfirm={closeSendFailModal}
      />
    </>
  );
}
